import { Component, Input } from '@angular/core';
import { TrainerModel } from 'src/app/models/trainer.model';

@Component({
  selector: 'app-trainer-group',
  standalone: false,
  templateUrl: './trainer-group.component.html',
  styleUrl: './trainer-group.component.scss',
})
export class TrainerGroupComponent {
  @Input() trainers: TrainerModel[] = [];
  @Input() maxAvatarsVisible: number = 3;

  get primaryTrainerName(): string {
    if (!this.trainers?.length) return '';
    const first = this.trainers[0];
    return `${first.firstName} ${first.lastName}`.trim();
  }

  get remainingCount(): number {
    return Math.max(0, (this.trainers?.length || 0) - 1);
  }

  get visibleTrainers(): TrainerModel[] {
    return this.trainers?.slice(0, this.maxAvatarsVisible) || [];
  }

  getInitials(trainer: TrainerModel): string {
    const firstInitial = trainer.firstName?.[0] || '';
    const lastInitial = trainer.lastName?.[0] || '';
    return (firstInitial + lastInitial).toUpperCase();
  }
}
